import CancelEditReceiverPopup from 'components/FormEditReceiver/components/CancelEditReceiverPopup';
import { RECEIVERS_PREFIX } from 'constants';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const withTriggerShowCancelUpdateReceiverModal = (Component) => {
  const TriggerShowCancelUpdateReceiverModalComponent = (props) => {
    const { cleanUpFn } = props || {};

    const navigate = useNavigate();

    const [isOpenCancelPopup, setOpenCancelPopup] = useState(false);

    const handleOnToggleCancelPopup = () => {
      setOpenCancelPopup((prev) => !prev);
    };
    const handleOnClickCancelPopup = () => {
      setOpenCancelPopup(false);
      cleanUpFn();
      navigate(`${RECEIVERS_PREFIX}`);
    };

    const newProps = {
      ...props,
      handleOnToggleCancelPopup,
      handleOnClickCancelPopup,
    };
    return (
      <>
        {isOpenCancelPopup ? (
          <CancelEditReceiverPopup
            isOpen={isOpenCancelPopup}
            onClose={handleOnToggleCancelPopup}
            onClick={handleOnClickCancelPopup}
          />
        ) : null}
        <Component {...newProps} />
      </>
    );
  };
  return TriggerShowCancelUpdateReceiverModalComponent;
};

export default withTriggerShowCancelUpdateReceiverModal;
